var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-select-native w-100"},[_c('vue-select',{style:(_vm.styleCustom),attrs:{"multiple":_vm.isMultiple,"label":"text","placeholder":_vm.placeholder,"options":_vm.options},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }